// extracted by mini-css-extract-plugin
export default {"matrix-table--pad3":"r_bL ml-3","matrix-table--pad4":"r_bM ml-5","matrix-table__title":"r_bN","matrix-table__true":"r_bP","matrix-table__false":"r_bQ"};